import { ref, readonly } from 'vue';

const doesBrowserSupportCopyingImagesToClipboard = ref(
  typeof ClipboardItem !== 'undefined' &&
  !!window.navigator &&
  !!window.navigator.clipboard &&
  typeof window.navigator.clipboard.write === 'function'
);

function copyImageToClipboard(htmlImgElement: HTMLImageElement) {
  if (!doesBrowserSupportCopyingImagesToClipboard.value) {
    window.sc3WorkbenchLogger.error('Unable to copy image to clipboard - this browser does not support this action.');
    return;
  }

  if (!(htmlImgElement instanceof Element)) {
    window.sc3WorkbenchLogger.error('Unable to copy image to clipboard - htmlImgElement argument is falsy.');
    return;
  }

  const canvas = document.createElement('canvas');
  canvas.width = htmlImgElement.naturalWidth;
  canvas.height = htmlImgElement.naturalHeight;
  const context = canvas.getContext('2d');

  context?.drawImage(htmlImgElement, 0, 0);

  const canvasToBlobConversionPromise = new Promise<Blob>((resolve, reject) => {
    try {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Converted blob was null.'));
          return;
        }

        resolve(blob);
      });
    } catch (e) {
      window.sc3WorkbenchLogger.error('Failed to copy image to clipboard - error occurred while converting canvas to blob.', e);
      reject(e);
    }
  });

  window.navigator.clipboard
    .write([
      new ClipboardItem({ 'image/png': canvasToBlobConversionPromise })
    ])
    .catch(e => {
      window.sc3WorkbenchLogger.error('Failed to copy image to clipboard - error occurred while copying blob to clipboard.', e);
    });
}

export function useCopyImageToClipboard() {
  return {
    doesBrowserSupportCopyingImagesToClipboard: readonly(doesBrowserSupportCopyingImagesToClipboard),
    copyImageToClipboard
  };
}
